import { text, integer, index } from 'drizzle-orm/sqlite-core'
import { defineTable } from '@kubdee/sdk/schema'
import { connectorInstances } from './connectors-instances'

// ============================================================================
// connectors_sync_jobs — Queue for scheduled/batch operations per instance
//
// Covers polling (sync.inbox), reconciliation (sync.orders), token refresh,
// and backfills. Scheduler picks rows where `status='queued' AND
// scheduled_at <= now` ordered by scheduled_at.
// ============================================================================
export const connectorSyncJobs = defineTable(
  'connectors',
  'sync_jobs',
  {
    id: text('id').primaryKey(),
    instanceId: text('instance_id')
      .notNull()
      .references(() => connectorInstances.id, { onDelete: 'cascade' }),
    jobType: text('job_type').notNull(),
    status: text('status').notNull().default('queued'),
    scheduledAt: text('scheduled_at').notNull(),
    startedAt: text('started_at'),
    completedAt: text('completed_at'),
    error: text('error'),
    attempts: integer('attempts').notNull().default(0),
    maxAttempts: integer('max_attempts').notNull().default(3),
    payload: text('payload'),
    result: text('result'),
    createdAt: text('created_at').notNull(),
  },
  (table) => [
    index('connectors_sync_jobs_instance_status_idx').on(table.instanceId, table.status),
    index('connectors_sync_jobs_status_scheduled_idx').on(table.status, table.scheduledAt),
    index('connectors_sync_jobs_completed_at_idx').on(table.completedAt),
    index('connectors_sync_jobs_instance_type_idx').on(table.instanceId, table.jobType),
  ],
)

export type ConnectorSyncJob = typeof connectorSyncJobs.$inferSelect
export type NewConnectorSyncJob = typeof connectorSyncJobs.$inferInsert
